import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    title: 'Скиллы',
    subtitle: 'Скиллы для MCP',
    comingSoon: 'Скоро здесь появятся скиллы',
  },
  en: {
    title: 'Skills',
    subtitle: 'Skills for MCP',
    comingSoon: 'Skills are coming soon',
  },
})
